import React from 'react';
import './App.css';
import {Switch, Route, Redirect, withRouter} from "react-router-dom";
import 'antd/dist/antd.less';
import PageNotFoundLayout, {PageInternalErrorLayout, PageUnauthorizedLayout} from "./layouts/PageError/PageErrorLayout";
import axiosService from "./services/axios.service";

const LoginLayout = React.lazy(() => import('./layouts/Login/LoginLayout'));
const AdminLayout = React.lazy(() => import('./layouts/Admin/AdminLayout'));
const DefaultLayout = React.lazy(() => import('./layouts/Default/DefaultLayout'));

class App extends React.Component<any, any>{
    componentDidMount() {
        axiosService({attachAuth: false}).get(
            'sys/ping/'
        ).then(
            res => {
                if (!res?.status) {
                    this.props.history.push('/error');
                }
            }
        );
    }

    render() {
        return (
            <Switch>
                <Redirect exact from="/" to="/portal" />
                <Route path="/portal">
                    <DefaultLayout />
                </Route>
                <Route path="/login">
                    <LoginLayout />
                </Route>
                {/* <Route path="/admin">
                    <AdminLayout />
                </Route> */}
                <Redirect from='/admin' to='/portal' />
                <Route path="/unauthorized" component={PageUnauthorizedLayout} />
                <Route path="/error" component={PageInternalErrorLayout} />
                <Route component={PageNotFoundLayout} />
            </Switch>
        )
    }
}

export default withRouter(App);
